import { motion } from "framer-motion";

const CHAPTERS = [
    {
        number: "01",
        title: "Le Feu de Bois",
        text: "Chez Petit Veau, tout passe par la braise. Merguez, kebab, bavette : nos viandes sont grillées au feu de bois pour ce goût fumé qu'on ne trouve nulle part ailleurs.",
        image: "https://images.unsplash.com/photo-1606152196365-d1ce5ea838b5?auto=format&fit=crop&w=900&q=80",
        alt: "Cuisson à la braise au feu de bois",
    },
    {
        number: "02",
        title: "L'Assiette Généreuse",
        text: "Viande au choix, frites et salade croquante. Ici, on ne triche pas sur la quantité : l'assiette arrive remplie à bord, avec nos sauces.",
        image: "/assets/assiette.jpg",
        alt: "Assiette Petit Veau — viande braisée et crudités",
    },
];

export default function ManifestoChapters() {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32"
        >
            <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="font-mono2 mb-4 text-[11px] uppercase tracking-[0.3em] text-rose-400"
            >
                Le Manifeste
            </motion.p>
            <motion.h2
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, delay: 0.1 }}
                className="font-display max-w-2xl text-4xl font-black uppercase leading-none tracking-tight sm:text-5xl"
            >
                Deux règles. <span className="text-rose-500">Zéro compromis.</span>
            </motion.h2>

            <div className="mt-16 flex flex-col gap-20 sm:mt-24 sm:gap-28">
                {CHAPTERS.map((ch, i) => (
                    <motion.article
                        key={ch.number}
                        data-testid={`manifesto-chapter-${ch.number}`}
                        initial={{ opacity: 0, y: 48 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                        className={`grid grid-cols-1 items-center gap-10 lg:grid-cols-12 ${
                            i % 2 === 1 ? "lg:[direction:rtl]" : ""
                        }`}
                    >
                        <div className="lg:col-span-7 lg:[direction:ltr]">
                            <div className="group relative aspect-[16/10] overflow-hidden rounded-2xl border border-white/10">
                                <img
                                    src={ch.image}
                                    alt={ch.alt}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/60 to-transparent" />
                                <span className="text-stroke-red font-display absolute -bottom-3 right-4 select-none text-8xl font-black leading-none sm:text-9xl">
                                    {ch.number}
                                </span>
                            </div>
                        </div>
                        <div className="lg:col-span-5 lg:[direction:ltr]">
                            <span className="font-mono2 text-sm font-bold tracking-[0.3em] text-rose-500">
                                {ch.number} /
                            </span>
                            <h3 className="font-display mt-3 text-2xl font-black uppercase tracking-tight sm:text-3xl">
                                {ch.title}
                            </h3>
                            <p className="mt-5 max-w-md text-base leading-relaxed text-zinc-400">
                                {ch.text}
                            </p>
                            <div className="mt-7 h-px w-24 bg-rose-600/60" />
                        </div>
                    </motion.article>
                ))}
            </div>
        </section>
    );
}
